<app-cookies-banner></app-cookies-banner>
 <div class="max-w-[1200px] mx-auto px-4 pb-4  md:mt-0">
<router-outlet></router-outlet>
</div>
<!-- @if (showSpinner$ | async) {
  <app-loading-screen></app-loading-screen>
} -->
